/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { SubmissionError } from 'redux-form';
import { ROOT_URL_V2, getCSRFToken } from '../../../../config';
import PopupHeader from '../../../common/PopupHeader';
import LoadingSpinner from '../../../common/LoadingSpinner';
import { fetchClientAddressList } from '../../../../actions/ClientData';
import { fetchCalendarEvents } from '../../../../actions/Calendar';
import { AgentShiftForm } from '../AgentShiftForm';

import history from '../../../../history';

class CalendarEditShiftContainer extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isFetching: true,
            job: null,
            roleExtras: null,
        };
    }

    componentDidMount() {
        const { jobId } = this.props.match.params;
        axios({
            method: 'GET',
            url: `${ROOT_URL_V2}jobs/${jobId}`,
        })
            .then(response => {
                const { history } = this.props;
                const currentUrlParams = new URLSearchParams(
                    history.location.search,
                );
                const newStartTime = currentUrlParams.get('editafter')
                    ? moment(currentUrlParams.get('editafter')).format('HH:mm')
                    : null;
                const newStartDate = currentUrlParams.get('editafter')
                    ? moment(currentUrlParams.get('editafter')).format(
                          'YYYY-MM-DD',
                      )
                    : null;
                const jobData = response.data.content;
                if (!!jobData.is_editable || !!jobData.managed) {
                    const job = {
                        date: newStartDate || jobData.date,
                        duration: jobData.duration,
                        service: jobData.service,
                        role: jobData.role,
                        number_of_freelancers: jobData.number_of_freelancers,
                        start_time: newStartTime || jobData.start_time,
                        freelancer_pay_per_hour:
                            jobData.freelancer_pay_per_hour,
                        client_pay_per_hour: jobData.client_pay_per_hour,
                        vehicle_type: jobData.vehicle_type,
                        own_vehicle: jobData.own_vehicle,
                        adr: jobData.adr,
                        hiab: jobData.hiab,
                        minimum_delivery_box: jobData.minimum_delivery_box,
                        heavy_lifting: jobData.heavy_lifting,
                        supervisor: jobData.supervisor,
                        cocktail_making: jobData.cocktail_making,
                        food_preparation: jobData.food_preparation,
                        address1: jobData.address1,
                        address2: jobData.address2,
                        postcode: jobData.postcode,
                        city: jobData.city,
                        matching_mode: jobData.matching_mode,
                        backups_enabled: jobData.backups_enabled,
                        client: jobData.client_full.id,
                        freelancers_information:
                            jobData.freelancers_information,
                        client_full: jobData.client_full,
                        sous_chef: jobData.sous_chef,
                        commis_chef: jobData.commis_chef,
                        chef_de_partie: jobData.chef_de_partie,
                        pastry_chef: jobData.pastry_chef,
                    };

                    const roleExtras = {
                        role: jobData.role,
                        supervisor: jobData.supervisor,
                        heavy_lifting: jobData.heavy_lifting,
                        minimum_delivery_box: jobData.minimum_delivery_box,
                        vehicle_type: jobData.vehicle_type,
                        own_vehicle: jobData.own_vehicle,
                        adr: jobData.adr,
                        hiab: jobData.hiab,
                        cocktail_making: jobData.cocktail_making,
                        food_preparation: jobData.food_preparation,
                        sous_chef: jobData.sous_chef,
                        commis_chef: jobData.commis_chef,
                        chef_de_partie: jobData.chef_de_partie,
                        pastry_chef: jobData.pastry_chef,
                    };

                    this.setState({
                        isFetching: false,
                        job,
                        roleExtras,
                    });
                } else {
                    const currentUrlParams = new URLSearchParams(
                        history.location.search,
                    );
                    history.push({
                        pathname: '/jobs/calendar',
                        search: currentUrlParams.toString(),
                    });
                }
            })
            .catch(response => {
                console.log(response);
            });
    }

    onDismiss = () => {
        this.props.fetchClientAddressList([]);
        // const {history} = this.props;
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (currentUrlParams.get('page')) {
            currentUrlParams.delete('page');
        }
        currentUrlParams.delete('editafter');
        this.props.load(currentUrlParams, currentUrlParams.get('view'));
        history.push({
            pathname: '/jobs/calendar',
            search: currentUrlParams.toString(),
        });
    };

    handleSubmit(formValues) {
        const self = this;
        const { jobId } = this.props.match.params;
        axios({
            method: 'patch',
            url: `${ROOT_URL_V2}jobs/${jobId}/`,
            data: formValues,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                self.onDismiss();
                self.props.notification.success(
                    'Success',
                    `Job ${response.data.content.reference_number} successfully edited`,
                );
            })
            .catch(error => {
                throw new SubmissionError(error.response.data.meta.detail);
            });
    }

    render() {
        return (
            <div className="create-shift">
                <PopupHeader title="&nbsp;" onDismiss={this.onDismiss} />
                {(() => {
                    if (this.state.job) {
                        return (
                            <AgentShiftForm
                                mode="edit"
                                defaultJob={this.state.job}
                                roleExtras={this.state.roleExtras}
                                handleFormSubmit={this.handleSubmit.bind(this)}
                                onDismiss={this.onDismiss.bind(this)}
                            />
                        );
                    }
                    return (
                        <LoadingSpinner
                            className="shift-spinner"
                            backgroundColor="white"
                        />
                    );
                })()}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    fetchClientAddressList: address =>
        dispatch(fetchClientAddressList(address)),
    load: (query, view) => dispatch(fetchCalendarEvents(query, view)),
});
export default connect(null, mapDispatchToProps)(CalendarEditShiftContainer);
